<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <t-report-generate
          v-if="relationAccessSubValidation('sub-polimix-production-report-order')"
          enable-grouped-period enabled-total-by-period
          enable-generate-excel
          enable-generate-html
          v-model="reportProductionOrder"
          sub-validation-tag="sub-polimix-production-report-order"
          title="Relatório de Produção">

        <t-input-search v-model="reportProductionOrder.dateRange" date date-monthly enable-range
                        label="Data Produzido"/>

        <b-row>

          <t-input-search v-model="reportProductionOrder.stepCurrentProcessFlowStepId" :options="stepOptions"
                          label="Etapa (ordens em andamento)"
                          help="Ordens de Fabricação que estão em andamento poderão ser filtradas por etapa." select
                          cols="6"
                          placeholder="Todas"/>

          <t-input-search v-model="reportProductionOrder.operationStatusId"
                          :options="typeStatusProductionOptions"
                          label="Status Operacional" cols="6"
                          select/>

        </b-row>

        <b-row>

          <b-col cols="6">

            <t-input-search v-model="reportProductionOrder.groupProductId"
                            :options="groupProductOptions"
                            label="Grupo"
                            select/>
          </b-col>

          <b-col cols="6">

            <t-input-code-label material v-model="reportProductionOrder.materialId"/>

          </b-col>

        </b-row>

        <b-row>

          <t-input-search label="Modelo" v-model="reportProductionOrder.modelId"
                          :options="modelOptions" cols="6" select/>

          <t-input-search label="Forma Física" placeholder="Todas" v-model="reportProductionOrder.unitId"
                          cols="6"
                          :options="unitOptions" select/>

        </b-row>

        <t-input-search v-model="reportProductionOrder.typeNonConformanceId" select
                        :options="typeNonConformanceOptions"
                        label="Tipo Não Conformidade"/>

        <t-input v-model="reportProductionOrder.optionStatusOrder" required checkbox
                 :options="statusOrderOptions"
                 label="Status Geral"/>


        <t-input-search v-model="reportProductionOrder.hasStock" :options="yesOrNotOptions" label="Está no estoque?"
                        boolean/>

      </t-report-generate>

      <t-report-generate
          v-if="relationAccessSubValidation('sub-polimix-production-report-reprocess')"
          enable-grouped-period enabled-total-by-period
          enable-generate-excel
          enable-generate-html
          v-model="reportProductionReprocess"
          sub-validation-tag="sub-polimix-production-report-reprocess"
          title="Relatório de Reprocessamento">

        <t-input-search v-model="reportProductionReprocess.dateRange" date date-monthly enable-range
                        label="Data Reprocessado"/>

        <t-input-search v-model="reportProductionReprocess.issueRange" date enable-range
                        label="Data Produzido"/>

      </t-report-generate>

      <ReportExtractProductionByStep v-if="relationAccessSubValidation('sub-production-report-extract-by-step-order')"
                                     :status-order-options="statusOrderOptions"/>


    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import ProcessFlowStepService from "@/services/modules/production/ProcessFlowStep.service";
import GroupProductService from "@/services/modules/product/GroupProduct.service";
import UnitService from "@/services/modules/product/Unit.service";
import TypeStatusProductionService from "@/services/modules/production/TypeStatusProduction.service";
import ReportExtractProductionByStep from "@/views/modules/production/Report/ReportExtractProductionByStep";
import ModelService from "@/services/modules/product/Model.service";
import TypeNonConformanceService from "@/services/modules/production/TypeNonConformance.service";


export default {

  mixins: [pageDefaultMixin],
  components: {ReportExtractProductionByStep},
  name: 'PolimixProductionReport',
  data() {
    return {
      path: "production/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      reportProductionOrder: {
        dateRange: "",
        stepCurrentProcessFlowStepId: 0,
        typeNonConformanceId: 0,
        groupProductId: 0,
        materialId: 0,
        unitId: 0,
        operationStatusId: 0,
        optionStatusOrder: [4, 10, 91],
        hasStock: null,
      },
      reportProductionReprocess: {
        dateRange: "",
        issueRange: "",
        typeStopId: 0,
      },
      statusOrderOptions: [{value: 4, text: 'Em Andamento'}, {value: 10, text: 'Produzido'}, {
        value: 91,
        text: 'Reprovado'
      }],
      typeStatusProductionOptions: [],
      stepOptions: [],
      groupProductOptions: [],
      unitOptions: [],
      modelOptions: [],
      typeNonConformanceOptions: [],
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await ProcessFlowStepService.selectList(0, true)
          .then(list => this.stepOptions = list)
          .catch(error => this.responseError(error))

      await GroupProductService.selectList().then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

      await TypeNonConformanceService.selectList().then((response) => {
        this.typeNonConformanceOptions = response
      }).catch(error => this.responseError(error))

      await UnitService.selectList().then((response) => {
        this.unitOptions = response
      }).catch(error => this.responseError(error))

      await ModelService.selectList().then((list) => {
        this.modelOptions = list
      }).catch(error => this.responseError(error))

      await TypeStatusProductionService.selectList("")
          .then(list => this.typeStatusProductionOptions = list)
          .catch(error => this.responseError(error))

    },

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
